export default __webpack_public_path__ + "static/media/photo--lg--24.89ff6951.jpg";